export default interface Preferences {
    showThumbnails: boolean,
    zoomLevel: string,
    showBookmarks: boolean,
}

export function tryLoadPrefs(): Preferences | undefined {
    const prefsString = localStorage.getItem("preferences");
    if (prefsString) {
        return JSON.parse(prefsString);
    }
}
